// extracted by mini-css-extract-plugin
export default {"actions":"confirm-modal_actions__ePQQt"};